 import TrackerContract from "./tracker-contract";
import AnalyticsService from "nandos-middleware-api/service/analytics-service";
import {_getOrderTypeFromBasket, _toMoney, getTrackingDataFromItem, MIDDLEWARE_SERVICE_EVENTS} from "../utils/utils";

export default class FacebookAnalyticsTracker extends TrackerContract {
  
  constructor () {
    super();
  }
  

  addToCart (products) { /* Products or GiftCards */
    products = Array.isArray(products) ? products : [products]
    _track(MIDDLEWARE_SERVICE_EVENTS.addToCart, {
      products: products.map(product => getTrackingDataFromItem(product))
    })
  }

  checkout (step, basket) {
    const data = {
        step: step,
    }
    
    if (basket) {
      data.products = basket.items.map(getTrackingDataFromItem)
    }
    _track(MIDDLEWARE_SERVICE_EVENTS.checkout, data)
  }

  purchase (transactionId, basket, affiliation) {
    let data = {
      products: basket.items.map(getTrackingDataFromItem),
      actionField: {
        id: transactionId,
        revenue: _toMoney(basket.totalPrice),
        shipping: basket.deliveryPrice ? _toMoney(basket.deliveryPrice) : undefined,
        tax: _toMoney(basket.totalVat),
        orderType: _getOrderTypeFromBasket(basket),
        affiliation,
      },
    }
    
    _track(MIDDLEWARE_SERVICE_EVENTS.purchase, data)
  }
 
  
}


function _track (event, eventData = {}) {
  if (Array.isArray(eventData)) eventData = { data: eventData }
  
  // attach cookie values for fb:
  if(document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(';').reduce((o, c) => {
      const keys = c.split('=')
      o[keys[0].trim()] = keys[1].trim()
      return o
    }, {})

    eventData.fbp = cookies._fbp
    eventData.fbc = cookies._fbc
  }

  AnalyticsService.track('fb',event, eventData)
}